/**
 * After a successful flex_schedule PATCH, push flex ignore zone preset selections
 * (camera-schedule-preset) from the onboarding store. Dynamic import avoids a
 * circular dependency between siteAboutStore and flexIgnoreZonesOnboardingStore.
 */
export async function persistFlexSchedulePresetAssignmentsAfterPatch(
  siteId: number,
  flexSchedulesResponse: Array<{ id?: number }>
): Promise<void> {
  try {
    const { useFlexIgnoreZonesOnboardingStore } = await import(
      "../FlexIgnoreZonesOnboarding/flexIgnoreZonesOnboardingStore"
    );
    const persistResult = await useFlexIgnoreZonesOnboardingStore
      .getState()
      .persistFlexSchedulePresetAssignments(siteId, flexSchedulesResponse);
    if (!persistResult.ok) {
      alert(
        persistResult.error ||
          "Schedule times were saved, but flex ignore zone preset assignments could not be updated."
      );
    }
  } catch {
    alert(
      "Schedule times were saved, but flex ignore zone preset assignments could not be updated."
    );
  }
}
